import { render, staticRenderFns } from "./QuizAnswerMediaContent.vue?vue&type=template&id=7cce2e34&"
import script from "./QuizAnswerMediaContent.vue?vue&type=script&lang=js&"
export * from "./QuizAnswerMediaContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports